// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (max-width:800px){.follow-button[data-v-22c1a64c]:not(.keep-text) span{display:none}}.follow-button.toggle-button.none.icon-only[data-v-22c1a64c]{color:#767d8a;color:var(--text-secondary,#767d8a)}.follow-button.toggle-button.none.icon-only[data-v-22c1a64c] .icon{font-size:1.5rem}.follow-button.toggle-button.none.active[data-v-22c1a64c]{background:none;color:#2f0db9;color:var(--primary-500,#2f0db9)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
